// PROJECT
export const PROJECT_DELETE = 'PROJECT_DELETE';
export const PROJECT_UPDATE = 'PROJECT_UPDATE';
export const PROJECT_CREATE = 'PROJECT_CREATE';
export const PROJECT_DUPLICATE = 'PROJECT_DUPLICATE';

// CODE
export const CODE_CREATE = 'CODE_CREATE';
export const CODE_UPDATE = 'CODE_UPDATE';
export const CODE_DELETE = 'CODE_DELETE';
export const CODE_DUPLICATE = 'CODE_DUPLICATE';

// USER
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_REVOKE = 'USER_REVOKE';
export const USER_DELETE = 'USER_DELETE';
export const USER_SET_INVITE_TOKEN = 'USER_SET_INVITE_TOKEN';
export const USER_SET_AUTH_DATA = 'USER_SET_AUTH_DATA';
export const USER_SET_DATA = 'USER_SET_DATA';
export const USER_INIT_LOCAL_CONFIG = 'USER_GET_LOCAL_CONFIG';
export const USER_KICK_LEASE_STARTED = 'USER_KICK_LEASE_STARTED';
export const USER_KICK_LEASE_COMPLETED = 'USER_KICK_LEASE_COMPLETED';
export const USER_LICENSE_CHECK_STARTED = 'USER_LICENSE_CHECK_STARTED';
export const USER_LICENSE_CHECK_COMPLETED = 'USER_LICENSE_CHECK_COMPLETED';
export const USER_SET_LOCAL_CONFIG = 'USER_SET_LOCAL_CONFIG';
export const USER_UNSET_LOCAL_CONFIG = 'USER_UNSET_LOCAL_CONFIG';
export const USER_AUTHENTICATION_STARTED = 'USER_AUTHENTICATION_STARTED';
export const USER_AUTHENTICATION_COMPLETED = 'USER_AUTHENTICATION_COMPLETED';
export const USER_AUTHENTICATION_FAILED = 'USER_AUTHENTICATION_FAILED';
export const USER_CAN_HAVE_TRIAL = 'USER_CAN_HAVE_TRIAL';
export const USER_SET_LEASE_DATA = 'USER_SET_LEASE_DATA';
export const USER_SET_SUBSCRIPTIONS_AVAILABILITY = 'USER_SET_SUBSCRIPTIONS_AVAILABILITY';

// NOTIFICATION
export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';
export const NOTIFICATION_UPDATE = 'NOTIFICATION_UPDATE';
export const NOTIFICATION_HOLD = 'NOTIFICATION_HOLD';
export const NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE';
export const NOTIFICATION_UNHOLD = 'NOTIFICATION_UNHOLD';

// SOURCE
export const SOURCE_DELETE = 'SOURCE_DELETE';
export const SOURCE_UPDATE = 'SOURCE_UPDATE';
export const SOURCE_CREATE = 'SOURCE_CREATE';
export const SOURCE_DUPLICATE = 'SOURCE_DUPLICATE';

// QUOTATION
export const QUOTATION_CREATE = 'QUOTATION_CREATE';

// GROUP
export const GROUP_DELETE = 'GROUP_DELETE';
export const GROUP_DELETED = 'GROUP_DELETED';
export const GROUP_RESTORED = 'GROUP_RESTORED';
export const GROUP_UPDATE = 'GROUP_UPDATE';
export const GROUP_CREATE = 'GROUP_CREATE';

// VIEW
export const VIEW_DELETE = 'VIEW_DELETE';
export const VIEW_DELETED = 'VIEW_DELETED';
export const VIEW_RESTORED = 'VIEW_RESTORED';
export const VIEW_UPDATE = 'VIEW_UPDATE';
export const VIEW_CREATE = 'VIEW_CREATE';

// REPORT
export const REPORT_CREATE = 'REPORT_CREATE';
export const REPORT_DUPLICATE = 'REPORT_DUPLICATE';

// MODAL
export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';
export const MODAL_UPDATE_PAYLOAD = 'MODAL_UPDATE_PAYLOAD';

// COMMANDS
export const COMMANDS_ADD = 'COMMANDS_ADD';
export const COMMANDS_REMOVE = 'COMMANDS_REMOVE';

// TRACKING
export const TRACKING_SET_CONSENT = 'TRACKING_SET_CONSENT';
export const TRACKING_INCREMENT_COUNT = 'TRACKING_INCREMENT_COUNT';

// AI CODING
export const AI_CODING_INIT_CONFIG = 'AI_CODING_INIT_CONFIG';
export const AI_CODING_SET_DONT_SHOW_AI_CODING_INFO = 'AI_CODING_SET_DONT_SHOW_AI_CODING_INFO';
export const AI_CODING_UPDATE_SPLASH_COOLDOWN = 'AI_CODING_UPDATE_SPLASH_COOLDOWN';
export const AI_CODING_SET_RESEARCH_GOAL = 'AI_CODING_SET_RESEARCH_GOAL';
export const AI_CODING_SET_QUESTIONS = 'AI_CODING_SET_QUESTIONS';
export const AI_CODING_RESET_CURRENT = 'AI_CODING_RESET_CURRENT';

// AI ASSISTANT
export const AI_ASSISTANT_INIT_CONFIG = 'AI_ASSISTANT_INIT_CONFIG';
export const AI_ASSISTANT_SET_IS_OPEN = 'AI_ASSISTANT_SET_IS_OPEN';

// GRID WRAP
export const GRID_WRAP_INITIALIZE = 'GRID_WRAP_INITIALIZE';
export const GRID_WRAP_SET_COLUMN = 'GRID_WRAP_SET_COLUMN';
export const GRID_WRAP_RESET = 'GRID_WRAP_RESET';
